<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
import { error, success } from "../../../../public/my-theme";
import type { Fn } from "../../../global";
import type { Third } from "../../../Model/Third";
import type { Witness } from "../../../Model/Witness";
import { witnessService } from "../../../services";
import WitnessInfoForm from "./WitnessInfoForm.svelte";

  export let witnessThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, witnessThird)

  let size = "lg";
  let witness: Witness;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {
      let witnessArray: Witness[] = await witnessService.findByDiligenceNumber(diligenceId)
      witness = witnessArray.find(c => c.witnessThird == denouncedThird.id)
    }
  }

  async function saveWitness() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    witness.witnessThird = third.id;
    save()
  }

  async function save(){
    await witnessService.saveWitness(witness);

    dispatch('saveWitness');
  }

</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>
    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if witness}
          <WitnessInfoForm witness={witness} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
    </TabContent>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveWitness}>Guardar</button>
  </ModalFooter>
</Modal>

